import React, { useState } from 'react';
import { ChevronDownIcon } from './icons';

export interface StatCardProps {
    title: string;
    value: string | number | React.ReactNode;
    icon: React.ReactNode;
    detailContent: React.ReactNode;
}

export const StatCard: React.FC<StatCardProps> = ({ title, value, icon, detailContent }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div 
            onClick={() => setIsExpanded(!isExpanded)}
            className={`bg-white dark:bg-slate-800/50 rounded-3xl shadow-soft border border-slate-100 dark:border-slate-700/50 transition-all duration-500 cursor-pointer overflow-hidden group ${isExpanded ? 'ring-2 ring-primary-500 shadow-luxury -translate-y-1' : 'hover:shadow-md hover:-translate-y-0.5'}`}
        >
            <div className="p-6">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4">
                        <div className={`p-3 rounded-2xl transition-colors duration-500 ${isExpanded ? 'bg-primary-500 text-white' : 'bg-primary-50 dark:bg-primary-900/20 text-primary-500'}`}>
                            {icon}
                        </div>
                        <div>
                            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">{title}</p>
                            <p className="text-2xl font-extrabold text-slate-900 dark:text-white mt-0.5">{value}</p>
                        </div>
                    </div>
                    <div className={`transition-transform duration-500 ${isExpanded ? 'rotate-180 text-primary-500' : 'text-slate-300'}`}>
                        <ChevronDownIcon />
                    </div>
                </div>
            </div>

            <div className={`transition-all duration-500 ease-in-out bg-slate-50/50 dark:bg-slate-900/30 border-t border-slate-50 dark:border-slate-700/50 ${isExpanded ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0 invisible'}`}>
                <div className="p-6">
                    {detailContent}
                </div>
            </div>
        </div>
    );
};
